import React from 'react';
import logo from '../../assets/images/dlg-logo.svg';

const DlgLogo: React.FC = () => {
  return <img src={logo} style={{ width: 56, height: 56, borderRadius: 50 }} />;
};

export default DlgLogo;
